export default __webpack_public_path__ + "static/icon-21-4-354ef3a00eed5b7d152fc77da8875b0b.png";